module.exports = __webpack_public_path__ + "static/img/4.ae2edb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/4.png
// module id = yvrs
// module chunks = 0